import Vue from 'vue'
import '../picture/picture.vue'

export default el => new Vue({
  name: 'Hero 404',
  el,
  mounted() {
    document.body.classList.add('force-active-nav')
  }
})
